import { Brand } from '@/domainLogic/index.ts';
import { UserRoleDomain } from '@lmn/nextjs-appfw/dist/casper/constants';
import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { SearchInfoData } from '@/app/search/types.ts';
import type { CommonData } from '@/app/common/createCommonData.ts';
import type { Localization } from '../common/Localization';

export type PinkPeopleLocalization = Pick<Localization, 'isWhiteLabel' | 'isTelesales' | 'businessProfile'> & {
  brand: string | undefined;
  configValuesApp: Pick<Localization['configValuesApp'], 'pinkPeopleEnabled' | 'pinkPeopleBP'>;
};

type GetIsPinkPeopleEnabled = {
  searchInfoData: Pick<SearchInfoData, 'isLiveSearch'>;
  commonData: Pick<CommonData, 'userRoleDomain'>;
  localization: PinkPeopleLocalization;
};

export const getIsPinkPeopleEnabled = ({
  searchInfoData,
  commonData,
  localization,
}: GetIsPinkPeopleEnabled): boolean => {
  const isEmployeeFromCasper = commonData.userRoleDomain === UserRoleDomain.EMPLOYEE;
  const isEmployee = isEmployeeFromCasper;

  const pinkPeopleEnabled = localization?.configValuesApp?.pinkPeopleEnabled;

  return (
    searchInfoData.isLiveSearch &&
    isEmployee &&
    pinkPeopleEnabled &&
    localization?.brand === Brand.LASTMINUTE &&
    !localization?.isWhiteLabel &&
    !localization?.isTelesales
  );
};

const pinkPeopleParamsToRemove: URLParameters[] = [URLParameters.BUSINESS_PROFILE_ID, URLParameters.PINK_PEOPLE];

export const containsAnyPinkPeopleParams = (searchParams: SearchParams, localization: Localization): boolean =>
  searchParams[URLParameters.PINK_PEOPLE] !== undefined ||
  searchParams[URLParameters.BUSINESS_PROFILE_ID] === localization.configValuesApp?.pinkPeopleBP;

export const removePinkPeopleParams = (searchParams: SearchParams): SearchParams =>
  Object.entries(searchParams).reduce(
    (result, [key, value]) =>
      pinkPeopleParamsToRemove.indexOf(key as URLParameters) >= 0 ? result : { ...result, [key]: value },
    {}
  );
